import * as Yup from 'yup'

export const WarrantyBoardCrewSortSchema = Yup.object().shape({
    sorted_crew: Yup.array().of(Yup.object().shape({
        id: Yup.number().required()
    }))
})